'use client';
/**
 * Позволяет выполнить `reject` по таймауту.
 *
 * @typeParam T - Содержимое Promise.
 * @typeParam E - Тип выбрасываемой ошибки.
 *
 * @param promise - Произвольный `Promise`.
 * @param timeout - Время в мс до выполнения `reject`.
 * @param error - Выбрасываемая при reject по таймеру ошибка.
 *
 * @returns Promise того же типа, что и переданный `promise`.
 *
 * @example
 *
 * ```ts
 * const timeoutError = Symbol();
 *
 * try {
 * 	   const result = await withTimeout(promise, 1000, timeoutError);
 * 	   // Обработка результата
 * } catch (error) {
 * 	   if (error === timeoutError) {
 * 	  	  // Обработка ошибки таймаута
 * 	   } else {
 * 	  	  throw error;
 * 	   }
 * }
 * ```
 *
 * @stable
 * */ var withTimeout = function(promise, timeout, error) {
    return Promise.race([
        promise,
        new Promise(function(_resolve, reject) {
            var timer = setTimeout(function() {
                clearTimeout(timer);
                reject(error);
            }, timeout);
        })
    ]);
};

export { withTimeout };
